import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, of, ReplaySubject} from 'rxjs';
import {first, takeUntil} from 'rxjs/operators';
import {User} from '../../../shared/interface/user';
import {UserService} from '../../../shared/services/user.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {RegionalService} from '../../../shared/services/regional.service';
import {Regional} from '../../../shared/interface/regional';
import {FormBuilder, FormControl} from '@angular/forms';
import {AvatarCropDialogComponent} from '../avatar-crop-dialog/avatar-crop-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {DictService, PARTNER_TAGS_GOOD_AGENT, PARTNER_TAGS_PROFIT} from '../../../shared/services/dict.service';
import {Dictionary} from '../../../shared/interface/dictionary';
import {Partner} from "../../../shared/interface/partner";
import {Ofwca} from "../../../shared/interface/ofwca";
import {PartnerService} from "../../../shared/services/partner.service";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {PermissionsTag} from "../../../shared/interface/permissions-tag";
import {PermissionTagsService} from "../../../shared/services/permission-tags.service";
import {Router} from "@angular/router";
import {DynamicDictionary} from "../../../shared/interface/dynamic-dictionary";
import {DynamicDictService} from "../../../shared/services/dynamic-dict.service";

@Component({
  selector: 'app-user-details-view',
  templateUrl: './user-details-view.component.html',
  styleUrls: ['./user-details-view.component.scss']
})
export class UserDetailsViewComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() user: Observable<User>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() avatarChanged = new EventEmitter<any>();

  userObject?: User;
  regionalName?: string;

  @ViewChild('avatarSelect') avatarSelect: ElementRef;
  avatarSelectControl: FormControl;
  imgCnt = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  tags: Dictionary[] = [];
  tags360: DynamicDictionary[] = [];
  permissionTag: PermissionsTag[] = [];

  partnerToggle = false;
  partner?: Partner;
  ofwca?: Ofwca;
  ofwcaToggle = false;
  userPermissionss: UserPermissions;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private userService: UserService,
    private snack: MatSnackBar,
    private regionalsService: RegionalService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private auth: AuthService,
    private dictService: DictService,
    private dynamicDictService: DynamicDictService,
    private privateTagsService: PermissionTagsService,
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.avatarSelectControl = fb.control('');
  }

  public openFileDialog(): void {
    const e: HTMLElement = this.avatarSelect.nativeElement;
    e.click();
  }

  ngOnInit(): void {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });
    this.user
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user: User) => {
        this.userObject = user;
        this.loadRegional(user);
        this.loadTags(user);
        this.loadTags360(user);
        this.loadPermision(user);
        if (user.ofwcaId){
          this.ofwcaToggle = true;
          this.ofwcaService.get(user.ofwcaId)
            .subscribe((ofwca: Ofwca) => {
              this.ofwca = ofwca;
            });
        }
        if (user.partnerId){
          this.partnerToggle = true;
          this.partnerService.get(user.partnerId)
            .subscribe((partner: Partner) => {
              this.partner = partner;
            });
        }

      });
  }

  loadPermision(user: User): void {
    this.permissionTag = [];
    if (this.userPermissionss.asf_360.read) {
      user.permissionTag.forEach((tagId: number) => {
        this.privateTagsService.getDict(tagId)
          .subscribe((dict: PermissionsTag) => {
            this.permissionTag.push(dict);
          });
      });
    }
  }

  ngAfterViewInit(): void {
    this.avatarSelectControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        if (!this.avatarSelect.nativeElement.files[0]) {
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(this.avatarSelect.nativeElement.files[0]);
        reader.onload = () => {
          const fileBase64 = reader.result.toString();
          const dialogRef = this.dialog.open(AvatarCropDialogComponent, {
            width: '55%',
            data: {fileBase64, ratio: 1, roundCropper: true, maintainRatio: true, compressedFile: false},
            height: '610px',
            maxHeight: '90%',
            panelClass: 'full-height-dialog',
          });

          dialogRef.afterClosed().subscribe(result => {
            if (!result) {
              this.avatarSelectControl.reset();
              return;
            }

            this.userService.updateAvatar(this.userObject.uuid, result)
              .subscribe(() => {
                this.snack.open('Pomyślnie zmieniono zdjęcie', '', {duration: 2000});
                this.avatarChanged.emit(true);
                this.imgCnt++;
                this.avatarSelectControl.reset();
              }, (error: HttpErrorResponse) => {
                this.snack.open('Przy aktualizacji zdjęcia wystąpił błąd', error.status.toString(), {duration: 2000});
                this.avatarSelectControl.reset();
              });
          });
        };
      });
  }

  loadRegional(user: User): void {
    this.regionalName = '';

    if (user.regionalId) {
      this.regionalsService.getRegional(user.regionalId)
        .pipe(first())
        .subscribe((regional: Regional) => {
          this.regionalName = regional.firstName + ' ' + regional.lastName;
        });
    }
  }

  loadTags(user: User): void {
    this.tags = [];
    user.tags.forEach((tagId: number) => {
      this.dictService.getDict(tagId)
        .subscribe((dict: Dictionary) => {
          this.tags.push(dict);
        });
    });
  }
  loadTags360(user: User): void {
    this.tags360 = [];
    user.tags360.forEach((tagId: number) => {
      this.dynamicDictService.get(tagId)
        .subscribe((dict: DynamicDictionary) => {
          this.tags360.push(dict);
        });
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  sendInvitation(): void {
    this.userService.sendInvitation(this.userObject.uuid)
      .subscribe(() => {
        this.snack.open('Zaproszenie zostało wysłane', '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas wysyłania zaproszenia wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  setAvatar(): void {
    this.userPermissions.pipe(first())
      .subscribe((permissions: UserPermissions) => {
        if (permissions.user.write) {
          this.openFileDialog();
        }
      });
  }

  getRemindPasswordUrl(): void {
    this.userService.getRemindPassword(this.userObject.uuid)
      .subscribe((value: any) => {
        this.copyMessage(value.items.url);
      });
  }

  copyMessage(val: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka', '', {duration: 2000});

  }
}
